/* import __COLOCATED_TEMPLATE__ from './suggestion-list.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { type Topic } from 'embercom/components/reporting/automation/ai-insights/fin-insights/topics-data-resources';
import { taskFor } from 'ember-concurrency-ts';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';
import type AiContentLibraryApi from 'embercom/lib/ai-content-library/list-api';
import type ContentSuggestionsService from 'embercom/services/content-suggestions-service';

interface Args {
  selectedTopic: Topic;
  selectedSubTopic: string | null;
  showTopics?: boolean;
}

export default class SuggestionList extends Component<Args> {
  @service declare appService: AppService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;
  @service declare contentSuggestionsService: ContentSuggestionsService;

  @tracked declare listApi: AiContentLibraryApi;

  private boundPerformLoadSuggestions: () => Promise<void>;

  constructor(owner: any, args: any) {
    super(owner, args);
    this.boundPerformLoadSuggestions = this.performLoadSuggestions.bind(this);
    this.knowledgeHubDrawerEditorService.on('onDrawerClose', this.boundPerformLoadSuggestions);
  }

  willDestroy() {
    super.willDestroy();
    this.knowledgeHubDrawerEditorService.off('onDrawerClose', this.boundPerformLoadSuggestions);
  }

  get suggestions() {
    return this.contentSuggestionsService.suggestionsForTopic;
  }

  get isLoadingSuggestions() {
    return taskFor(this.contentSuggestionsService.loadSuggestionsForTopic).isRunning;
  }

  @action
  async performLoadSuggestions() {
    await taskFor(this.contentSuggestionsService.loadSuggestionsForTopic).perform(
      this.args.selectedTopic.name,
      this.args.selectedSubTopic,
    );
    await this.contentSuggestionsService.fetchTopicsSummary();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::SuggestionList': typeof SuggestionList;
  }
}
